import { useLocation } from '@reach/router'

export const useBlackBG = (): boolean => {
  const location = useLocation()
  return !!(
    location.pathname.startsWith('/product-learn/') ||
    location.pathname.startsWith('/product-digest/') ||
    location.pathname.startsWith('/product-heroes/')
  )
}
